<div class="row custom-last-child-margin pageBtnMargin">
  <div class="col-lg-12 col-md-12 col-sm-12">
    <div
      class="tabcontent-display-line-section-heading title-text title-padding-bottom"
    >
      <em class="material-icons custom-margin-right-icon">description</em>
      {{ "orderTracking.associateDocument" | cxTranslate }}
      <span
        class="download-all-txt"
        *ngIf="viewAllDocuments?.length > 0"
        [ngClass]="downloadAllLoader ? 'disabled' : ''"
        (click)="downloadAllFiles()"
        ><em class="icons download"></em
        >{{ "orderTracking.downloadAll" | cxTranslate }}</span
      >
      <div
        *ngIf="downloadAllLoader"
        class="title product-search-spinner cx-spinner"
      >
        <cx-spinner></cx-spinner>
      </div>
    </div>
  </div>

  <div
    class="col-lg-12 col-md-12 col-sm-12 mt-4 blocked-warning-message"
    *ngIf="viewAllDocuments?.length === 0"
  >
    <span class="obsolete-text">
      <em class="material-icons">info</em>
      <strong>&nbsp;{{ "orderTracking.information" | cxTranslate }}</strong
      >&nbsp; {{ "orderTracking.noDocAvailable" | cxTranslate }}</span
    >
  </div>

  <div *ngIf="viewAllDocuments?.length > 0">
    <div
      class="col-lg-12 col-md-12 col-sm-12 mt-4"
      *ngFor="let documentItem of viewAllDocuments; let i = index"
    >
      <div class="upload-block">
        <span
          class="material-icons vertical-middle"
          [ngClass]="downloadLoader[i] ? 'disabled' : ''"
          >insert_drive_file</span
        >
        <a
          (click)="downloadDocument(documentItem, i)"
          [ngClass]="downloadLoader[i] ? 'disabled' : ''"
          >{{ generateFileName(documentItem) }}</a
        >
        <!-- <span class="value-txt"></span> -->
        <div
          *ngIf="downloadLoader[i]"
          class="product-search-spinner cx-spinner"
        >
          <cx-spinner></cx-spinner>
        </div>
      </div>
    </div>
  </div>
</div>
